require('../core');

angular.module('ui-ng-time-input').directive('phxTimeInputFormatter', function phxTimeInputFormatter($filter) {
  var ERASE_SECONDS_AND_TIME_UNITS = /:\d{2}[.,]\d{3}$/;

  return {
    require: '?ngModel',
    link: function (scope, elem, attr, ngModel) {
      if (!ngModel) {
        return;
      }

      if (attr.type !== 'time') {
        return;
      }

      ngModel.$formatters.unshift(function (value) {
        return value.replace(ERASE_SECONDS_AND_TIME_UNITS, '');
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-time-input/src/core/formatter.js